import { ActivityCategory, activityCategories } from "@sp-crm/core";
import { Taskv2 } from "components/tasks/v2/types";
import { ActivityParent, visitParentFor } from "components/visits/types";
import { AdvancedSearchEntityType } from "generated/graphql";

const loggableActivityCategories = activityCategories.filter(
    category => category !== "event",
);

export const nonVisitActivityCategories = loggableActivityCategories.filter(
    category => category !== "visit",
);

export const activityParentPath = (parent: ActivityParent): string => {
    switch (parent.kind) {
        case "contact":
            return `/references/contacts/show/${parent.id}`;
        case "organization":
            return `/references/organizations/show/${parent.id}`;
        case "client":
            return `/clients/show/${parent.id}`;
        case "homeCareLead":
            return `/home-care-clients/show/${parent.id}`;
    }
    const exhaustiveCheck: never = parent;
    throw new Error(`Unhandled activity parent ${String(exhaustiveCheck)}`);
};

const entityTypeForParent = (parent: ActivityParent): AdvancedSearchEntityType => {
    switch (parent.kind) {
        case "contact":
            return AdvancedSearchEntityType.ReferenceContact;
        case "organization":
            return AdvancedSearchEntityType.ReferenceBusiness;
        case "client":
            return AdvancedSearchEntityType.Client;
        case "homeCareLead":
            return AdvancedSearchEntityType.HomeCareLead;
    }
    const exhaustiveCheck: never = parent;
    throw new Error(`Unhandled activity parent ${String(exhaustiveCheck)}`);
};

export const taskEntityForParent = (parent: ActivityParent): Taskv2["entity"] => ({
    displayName: parent.name,
    path: activityParentPath(parent),
    kind: entityTypeForParent(parent),
    contact: null as Taskv2["entity"]["contact"],
});

export const activityCategoriesForParent = (
    parent: ActivityParent,
): readonly ActivityCategory[] =>
    visitParentFor(parent) ? loggableActivityCategories : nonVisitActivityCategories;
